import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { API } from "@/lib/api";
import { faqJsonLd } from "@/lib/seo";

// The four real pre-purchase objections + the not-therapy line (source: /api/faq "before-you-begin").
export default function HomeFAQ() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`${API}/faq`)
      .then((r) => r.json())
      .then((d) => setItems((d.categories || []).find((c) => c.slug === "before-you-begin")?.questions || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="mt-24 max-w-3xl border-t border-obsidian-600 pt-14" data-testid="home-faq">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd(items))}</script>
      </Helmet>
      <p className="font-sans uppercase tracking-[0.28em] text-xs text-terracotta mb-6">Before you begin</p>
      <h2 className="font-serif text-2xl md:text-3xl text-bone-100 mb-10 leading-tight">
        What people ask before they pay.
      </h2>
      <dl className="space-y-8">
        {items.map((item, i) => (
          <div key={i} data-testid={`home-faq-item-${i}`}>
            <dt className="font-serif text-xl text-bone-100 mb-2">{item.q}</dt>
            <dd className="font-sans text-sm sm:text-base text-bone-300 leading-relaxed">{item.a}</dd>
          </div>
        ))}
      </dl>
      <div className="mt-10 flex flex-wrap gap-6">
        <Link to="/about" data-testid="home-faq-about-link" className="font-sans text-xs uppercase tracking-[0.24em] text-terracotta hover:text-bone-100">
          Read the founder's story →
        </Link>
        <Link to="/faq" data-testid="home-faq-all-link" className="font-sans text-xs uppercase tracking-[0.24em] text-bone-400 hover:text-terracotta">
          All questions →
        </Link>
        <Link to="/vs/the-shadow-work-journal" data-testid="home-faq-vs-book-link" className="font-sans text-xs uppercase tracking-[0.24em] text-bone-400 hover:text-terracotta">
          Umbra vs the printed workbook →
        </Link>
        <Link to="/vs/symponia" data-testid="home-faq-vs-voice-link" className="font-sans text-xs uppercase tracking-[0.24em] text-bone-400 hover:text-terracotta">
          Umbra vs a voice-first AI app →
        </Link>
      </div>
    </section>
  );
}
